import ConversationListBox from '@/components/AgentChat/AgentChatActiveConversationList/ConversationListBox';
import ConversationSearchListBox from '@/components/AgentChat/AgentChatActiveConversationList/ConversationSearchListBox';

// @vue/component
export default {
  name: 'AgentChatActiveConversationList',
  components: {
    ConversationListBox,
    ConversationSearchListBox,
  },
};
